// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import '../styles/start.css';
import Search from './Search';

export default class Welcome extends React.Component {

    state = {
        // Animation
        stage: 0,
        visible: false,
        blur: true
    }

    componentDidMount = () => {
        // return this.nextStage(null,10); // For testing only!
        setTimeout(() => this.setState({
            stage: 1,
            visible: true
        }), 500);
        setTimeout(() => this.nextStage(null, 2), 3000);
    }

    nextStage = (e, stage) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ visible: false });
        setTimeout(() => this.setState({
            stage: stage ? stage : this.state.stage+1,
            visible: true
        }),1000);
    }

    render = () => {
        const isAdmin = this.props.user ? this.props.user.isAdmin : false;
        const isOwner = this.props.user && this.props.team && this.props.user._id === this.props.team.owner;

        return (<div className={this.state.blur ? "welcome-container" : ""}>
            <div className="start-container">
                <div className={"welcome-content" + (!this.state.visible ? " start-content-hidden" : "")}>

                    {/* Welcome */}
                    {this.state.stage === 1 ? <>
                        <h1>Welcome to Stax<div className="navigation-logo-dot" />ai!</h1>
                    </> :

                    // Tour?
                    this.state.stage === 2 ? <>
                        <h1>Would you like a quick tour?</h1>
                        <div className="welcome-options">
                            <div
                                className="welcome-option-small"
                                onClick={(e) => isOwner ? this.nextStage(e, 9) : this.props.finish(e)}
                            >
                                Skip
                            </div>
                            <div
                                className="welcome-option-next"
                                onClick={(e) => {
                                    this.nextStage(e);
                                    setTimeout(() => {
                                        this.nextStage(null, 5);
                                        this.props.pulseUserIcon();
                                    }, 3000);
                                }}    
                            >
                                Show me around!
                            </div>
                        </div>
                    </> :
                    
                    this.state.stage === 3 ? <>
                        <h1>Alright! Let's go through the basics.</h1>
                    </> :

                    this.state.stage === 4 ? <>
                        <h1>Stacks are smart folders.</h1>
                        <p className="welcome-message">
                            When Stax<div className="navigation-logo-dot" />ai receives your files, it sorts them into your stacks. You just need to upload at least <strong>5</strong> to <strong>10</strong> documents for the AI bots to learn from, or pick a <strong>base model</strong>.
                            {isAdmin && <>
                                <br /><br />
                                You can <strong>create</strong> and <strong>manage</strong> your own stacks. Some example stacks can be <u>Legal</u>, <u>Billing</u>, <u>Resumes</u>, <u>Administrative</u> etc.<br /> The AI bots will follow your lead!
                            </>}
                        </p>
                        <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
                    </> :

                    this.state.stage === 5 ? <>
                        <h1>Your Stax<div className="navigation-logo-dot" />ai home page</h1>
                        <p className="welcome-message">
                            The <strong>My Stacks</strong> page is your dashboard. All of your stacks and workflows are listed here, including some <u>quick-access</u> stacks to help you stay organized.<br /><br />
                            <img
                                style={{
                                    width: 500,
                                    margin: '0 auto'
                                }}
                                src="https://static.stax.ai/images/graphics/guide-mystacks.png"
                                alt="My Stacks"
                            /><br />
                            <strong>Click</strong> on a stack to open it and view files within it.<br />
                            <strong>Right-click</strong> on a stack to see options such as open, rename, move, and delete.
                        </p>
                        <div className="welcome-next" onClick={() => {
                            this.nextStage();
                            this.props.pulseUserIcon();
                        }}>Next ⇾</div>
                    </> :

                    this.state.stage === 6 ? <>
                        <div
                            style={{
                                position: 'fixed',
                                right: 85,
                                top: 40,
                                textAlign: 'right'
                            }}
                        >
                            <img
                                src="https://static.stax.ai/images/graphics/arrow-right.png"
                                alt=""
                                style={{
                                    float: 'right',
                                    width: 80,
                                    height: 80,
                                    marginBottom: -10
                                }}
                            />
                            <div style={{ clear: 'both' }} />
                            <strong>Click to open the user panel</strong>
                        </div>
                        <h1>Your User Panel</h1>
                        <p className="welcome-message">
                            The user icon on the top-right corner is your <strong>user panel</strong>. You can view notifications, manage settings, and log out from here.
                            {isOwner && <>
                                <br /><br />
                                You can also access your team and account settings here including your connections, billing settings, TPA plans, and more!
                            </>}
                        </p>
                        <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
                    </> :

                    this.state.stage === 7 ? <>
                        <Search
                            disabled={true}
                            inputClassName="user-notified"
                        />
                        <h1>A search engine for <strong>your</strong> data!</h1>
                        <p className="welcome-message">
                            Stax<div className="navigation-logo-dot" />ai makes all of your company's documents <strong>searchable</strong>.
                            <br /><br />
                            Using the search bar next to the user icon, you can search <strong>through</strong> scans, faxes, and all of your other documents!
                        </p>
                        <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
                    </> :

                    this.state.stage === 8 ? <>
                        <h1>Learn as you go...</h1>
                        <p className="welcome-message">
                            Let's stop here for now. Start using Stax<div className="navigation-logo-dot" />ai to <strong>automate</strong> your <strong>document workflow</strong> and you'll figure out the rest in no time!
                            <br /><br />
                            If you have any questions, feel free to reach out to your <strong>Customer Success Representative</strong> and we'll take care of it for you!
                        </p>
                        {/* <div className="point-of-contact" >
                            <img
                                src="https://static.stax.ai/images/other/mckenzie.png"
                                alt="McKenzie Glandorf"
                            />
                            <h1>McKenzie Glandorf</h1>
                            <h2>VP of Customer success</h2>
                            <div 
                                className="point-of-contact-email"
                                onClick={() => window.open('mailto:mckenzie@stax.ai', '_blank')}
                            >mckenzie@stax.ai</div>
                        </div> */}
                        <div style={{ clear: 'both' }} />
                        <div className="welcome-next" onClick={this.props.finish}>Finish ⇾</div>
                    </> :
                    
                    // Make sure user starts checklist
                    this.state.stage === 9 ? <>
                        <h1>Let's start with your checklist!</h1>
                        <p>
                            First, <strong>click</strong> on your user icon on the top-right corner to open it.
                        </p><br />
                        <img
                            src="https://static.stax.ai/images/graphics/guide-checklist.png"
                            alt="Checklist"
                            style={{ width: 400 }}
                        /><br />
                        <p>
                            Follow the instructions on each checklist item to complete it.<br />
                            This is <strong>very important</strong> to get your account fully set up.
                        </p>
                        <div className="welcome-next" onClick={this.props.finish}>Finish ⇾</div>
                    </> : ""}

                </div>
            </div>
        </div>);
    }

};